import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AvatarModule } from '@nano/common/avatar';

import { UserMenuItemsModule } from '../shared/user-menu-items/user-menu-items.module';
import { UserComponent } from './user.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, AvatarModule, FormsModule, NzDropDownModule, NzIconModule, UserMenuItemsModule],
  declarations: [UserComponent],
  exports: [UserComponent]
})
export class UserModule {}
